import { getAxiosInstance } from '../blocks/axios/axiosFactory';

const url = "/businessSpace";

export default class BusinessSplaceService {
    static get() {
        return getAxiosInstance().get(`${url}/get`);
    }
}
